import RichSnippets from "./richsnippets";

import { CANONICAL_HOST } from "lib/http";

export default function SeoBreadcrumb({ category, product, subcategory1 }) {
  const data = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Murfy Shop",
        item: `${CANONICAL_HOST}/reconditionne`,
      },
    ],
  };

  if (category) {
    data.itemListElement.push({
      "@type": "ListItem",
      position: 2,
      name: category.name,
      item: `${CANONICAL_HOST}/reconditionne/${category.slug}`,
    });
  }

  if (subcategory1) {
    data.itemListElement.push({
      "@type": "ListItem",
      position: 3,
      name: subcategory1.name,
      item: `${CANONICAL_HOST}/reconditionne/${category.slug}/${subcategory1.slug}`,
    });
  }

  if (product && subcategory1) {
    data.itemListElement.push({
      "@type": "ListItem",
      position: 4,
      name: `${product.brand} ${product.model_reference}`,
      item: `${CANONICAL_HOST}/reconditionne/${category.slug}/${subcategory1.slug}/${product.slug}`,
    });
  }

  return <RichSnippets data={data} />;
}
